import { Pipe, PipeTransform } from "@angular/core";
import { DealerViewModel } from "src/domain/client";

@Pipe({ name: "filterDealer" })
export class FilterDealerPipe implements PipeTransform {
  transform(value: string, dealer: DealerViewModel): boolean {
    const dealerNameIndex =
      dealer.name != null
        ? dealer.name.toLowerCase().indexOf(value.toLowerCase())
        : -1;
    const dealerPostalCodeIndex =
      dealer.postalCode != null ? dealer.postalCode.indexOf(value) : -1;
    const dealerCityIndex =
      dealer.city != null
        ? dealer.city.toLowerCase().indexOf(value.toLowerCase())
        : -1;
    return (
      !!value &&
      (dealerNameIndex > -1 ||
        dealerPostalCodeIndex > -1 ||
        dealerCityIndex > -1)
    );
  }
}
